var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-more-button"},[_c('button',{on:{"click":function($event){return _vm.$emit('showMore')}}},[_vm._v("Show more")])])
}
var staticRenderFns = []

export { render, staticRenderFns }